/**
 * What a FAIL does to the list, under the FAIL chip. 21/10/2026: the Burned
 * row is gone — the conditions and their "It happened on" row decide when a
 * FAIL happens. 23/10/2026 (user: "list come back action … must be hidden
 * … replace it by stop list or complete list"): the one choice left is what
 * today does — the "A list fails" card, moved here; a FAILed list stays out
 * until Reset pool. The mechanics live behind the ⓘ.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import type { ContainerEditor } from '../../state/useContainerEditor';
import { FailModeRow } from './FailModeRow';

export const FailConsequence: FC<{ editor: ContainerEditor }> = ({ editor }) => (
  <div className="flex flex-col gap-1.5" data-testid="fail-consequence">
    {editor.draft.kind === 'ROUTE_TEST' ? null : <FailModeRow editor={editor} />}
  </div>
);
